import Head from 'next/head';
import { advertising } from '@/config/monetization'; // interface Props {}

import { jsx as _jsx } from "react/jsx-runtime";

const Advertisers = () => /*#__PURE__*/_jsx(Head, {
  children: advertising.active && /*#__PURE__*/_jsx("script", {
    async: true,
    src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4288864228810491",
    crossOrigin: "anonymous"
  })
});

export default Advertisers;